
<template>
    <div>
        <CRow class="mb-3 ml-2">
            <h3>회사수정</h3>
        </CRow>
        <form style="width: 100%">
            <CRow>
                <CCol md="6">
                    <CCard>
                        <CCardHeader>
                            <strong>회사정보</strong>
                        </CCardHeader>
                        <CCardBody>
                            <CForm>
                                <CInput
                                        label="회사명"
                                        description="회사명"
                                        placeholder="회사명"
                                        horizontal
                                        v-model="name"
                                        required
                                        was-validated
                                />
                                <CInput
                                        label="등록번호"
                                        placeholder="Text"
                                        description="단체등록번호(사업자번호)"
                                        horizontal
                                        v-model="registNo"
                                        required
                                        was-validated
                                />
                                <div role="group" class="form-group  form-row">
                                    <label for="uid-utosbj1koo" class="col-form-label col-sm-3"> 상태 </label>
                                    <div class="col-sm-9">
                                        <select id="uid-utosbj1koo"  v-model="enabledYn" required="required"  class="form-control select" style="border-color: #e55353">
                                            <option value="Y">활성화</option>
                                            <option value="N">비활성화</option>
                                        </select>
                                        <small class="form-text text-muted w-100">활성화/비활성화</small>
                                    </div>
                                </div>
                                <CInput
                                        label="대표주소"
                                        placeholder="Text"
                                        description="대표주소"
                                        horizontal
                                        v-model="companyAddress"
                                        required
                                        was-validated
                                />
                                <CInput
                                        label="대표전화번호"
                                        placeholder="Text"
                                        description="대표전화번호"
                                        horizontal
                                        v-model="companyTel"
                                        required
                                        was-validated
                                />
                                <CInput
                                        label="등록일"
                                        placeholder="정보등록일"
                                        description="정보 등록일"
                                        horizontal
                                        v-model="insertTime"
                                        Disabled

                                />
                                <CInput
                                        label="변경일"
                                        placeholder=""
                                        description="정보 등록일"
                                        horizontal
                                        v-model="updateTime"
                                        Disabled

                                />
                            </CForm>
                        </CCardBody>
                        <CCardFooter>
                            <CButton type="button" size="sm" color="primary"   @click="submit"><CIcon name="cil-check-circle"/> 저장</CButton>
                        </CCardFooter>
                    </CCard>
                </CCol>
            </CRow>
        </form>
    </div>
</template>
<style>
    .btn-col-margin{
        margin-top: 5px;
        margin-left: 15px;
        margin-right: 10px;
    }
    .col-title{
        width: 20%;
    }
    .table-span-margin{
        margin-left: 10%;
    }
</style>
<script>
    import Vue from 'vue'
    import axios from "axios";
    import VueMoment from 'vue-moment'

    Vue.use(VueMoment)

    export default {
        name: 'paymanageupdate',
        components: {
        },
        data() {
            return{
                options: ['입원', '퇴원'],
                companyItem: {},
                item: null,
                insertTime: '',
                updateTime: '',
                name: '',
                enabledYn: '',
                registNo: '',
                companyId:this.$route.params.companyId,
                companyAddress: '',
                companyTel: '',

            }
        },
        filters:{
            comma(val){
                return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
        },
        mounted() {
            const companyId = this.$route.params.companyId;

            axios.get('silver/company/update/'+companyId)
                .then(res => {
                    this.companyId = companyId;
                    this.companyItem = res.data.company;
                    this.name = res.data.name;
                    this.registNo = res.data.registNo;
                    this.companyAddress = res.data.companyAddress;
                    this.companyTel = res.data.companyTel;
                    this.insertTime =  this.$moment(res.data.insertTime).format('YYYY-MM-DD');
                    this.updateTime = this.$moment(res.data.updateTime).format('YYYY-MM-DD');


                    if(res.data.updateTime === null || res.data.updateTime === ""){
                        this.updateTime = '';
                    }else {
                        this.updateTime = this.$moment(res.data.updateTime).format('YYYY-MM-DD');
                    }
                    this.enabledYn = res.data.enabledYn;
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        methods: {
            submit () {
                if(this.insertTime == 'Invalid date'){
                    this.insertTime = ''
                }
                if(this.updateTime == 'Invalid date'){
                    this.updateTime = ''
                }
                if(this.registNo == null){
                    this.registNo=''
                }
                if(this.companyAddress == null){
                    this.companyAddress=''
                }
                if(this.companyTel == null){
                    this.companyTel=''
                }

                axios.post('/silver/company/update/action', {
                    companyId: this.companyId,
                    name: this.name,
                    registNo: this.registNo,
                    companyAddress:  this.companyAddress,
                    companyTel:  this.companyTel,
                    enabledYn:this.enabledYn,
                    insertTime: this.insertTime,
                    updateTIme: this.updateTIme
                })
                    .then(data => {
                        this.$router.push({name:"companylist"})
                    })
                    .catch(function (error) {
                        console.log(error)
                    });
            },
            comma(val){
                return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
        }
    }
</script>
